module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/next-193.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/changelog/next.md
// module id = 636
// module chunks = 421